import './index.css'

const MatchCard = props => {
  const {recentMatchDetails} = props
  const {
    result,
    competingTeam,
    competingTeamLogo,
    matchStatus,
  } = recentMatchDetails

  return (
    <li className="recent-match-card">
      <img
        className="recent-match-logo"
        alt={`competing team ${competingTeam}`}
        src={competingTeamLogo}
      />
      <p className="recent-match-team">{competingTeam}</p>
      <p className="recent-match-result">{result}</p>
      <p className={`recent-match-status ${matchStatus.toLowerCase()}`}>
        {matchStatus}
      </p>
    </li>
  )
}

export default MatchCard
